import type { FC, ReactElement } from 'react';

import { useLegacyContext } from '../../components/legacyMode/LegacyContextProvider';
import { chatCommunicationController } from '../../controllers/chatCommunication/ChatCommunicationControllerConnector';
import { L10nText } from '../../services/uiTranslations/reactBindings/L10nText';
import { useCoreDispatch } from '../../store/CoreStore';
import { useConfigSlice } from '../../store/slices/config/selectors';
import { useSettingsSlice } from '../../store/slices/settings/selectors';
import { settingsActions } from '../../store/slices/settings/slice';
import { useIsLegacyDesktop } from '../../styles/hooks/legacyMedia';
import { ControlContainer } from '../controls/controlContainer/ControlContainer';
import { Toggle } from '../controls/toggle/Toggle';

export const SettingsChatConnected: FC = (): ReactElement => {
  const userId = useConfigSlice.userId();
  const showOtherMessages = useSettingsSlice.getShowOtherMessages();
  const { isLegacyMode } = useLegacyContext();
  const isLegacyDesktop = useIsLegacyDesktop();
  const showOffset = !isLegacyMode || !isLegacyDesktop;

  const dispatch = useCoreDispatch();

  const handleChatToggle = (checked: boolean): void => {
    dispatch(settingsActions.setShowOtherMessages(checked));

    chatCommunicationController.sendMessage(
      JSON.stringify({
        action: 'SETTINGS',
        messageId: `${userId}_${Date.now()}`,
        preference: {
          showOtherMessages: checked,
        },
        userId,
      })
    );
  };

  return (
    <ControlContainer label={<L10nText tk="SETTINGS_SHOW_OTHER_PLAYERS_MESSAGES" />} offset={showOffset}>
      <Toggle checked={showOtherMessages} onChange={(event) => handleChatToggle(event.target.checked)} />
    </ControlContainer>
  );
};
